import { render, staticRenderFns } from "./mensagemOptions.vue?vue&type=template&id=14b32e37"
import script from "./mensagemOptions.ts?vue&type=script&lang=js&external"
export * from "./mensagemOptions.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b32e37')) {
      api.createRecord('14b32e37', component.options)
    } else {
      api.reload('14b32e37', component.options)
    }
    module.hot.accept("./mensagemOptions.vue?vue&type=template&id=14b32e37", function () {
      api.rerender('14b32e37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/mensagem/mensagemOptions/mensagemOptions.vue"
export default component.exports